import { BsCheckCircleFill, BsCircle } from "react-icons/bs";
import { generateIcon } from "utils";
import React from "react";
import { useAiFilterContext } from "../../context";

interface IAiFiltersSelectableItemProps {
  children: React.ReactNode;
  id: string;
  isSelectable?: boolean;
  selectedElements?: string[];
  handleSelect?: () => void;
  itemName: string;
  locked?: boolean;
}

export default function AiFiltersSelectableItem({
  children,
  id,
  isSelectable = true,
  selectedElements,
  handleSelect,
  itemName,
  locked = false,
}: IAiFiltersSelectableItemProps) {
  const { selectedItems, selectItem, isSelected } = useAiFilterContext();
  const selectedList = selectedElements ? selectedElements : selectedItems;

  const getSelectBtnClassName = (_id: string) => {
    return isSelected(_id)
      ? `text-purple-950 left-1 top-1 bg-white rounded-full block`
      : `text-white ${
          selectedList.length > 0
            ? "opacity-60"
            : "opacity-40 lg:opacity-0 group-hover/item:opacity-60 group-hover/item:hover:opacity-100"
        }`;
  };
  const getSelectButtonIcon = (_id: string) => {
    if (selectedList.length > 0 && !isSelected(_id)) {
      return generateIcon(
        BsCircle,
        "text-[16px] scale-[1.35] box-shadow-[0 0 0px 1px #fff inset]"
      );
    }

    return generateIcon(BsCheckCircleFill, "text-[16px] scale-[1.35]");
  };

  if (!isSelectable) {
    return <div className="relative group bg-gray-200">{children}</div>;
  }

  return (
    <div className="relative group/item bg-gray-200">
      {!locked && (
        <span
          className="absolute top-[2px] left-[2px] z-30 cursor-pointer p-3 rounded-full"
          onClick={() => (handleSelect ? handleSelect() : selectItem(id))}
        >
          <span className={getSelectBtnClassName(id)} title="Kijelölés">
            {getSelectButtonIcon(id)}
          </span>
        </span>
      )}

      <div className="transition-all overflow-hidden">{children}</div>
      <span className="absolute bottom-0 w-full text-center bg-[#374151] text-white">
        {itemName || ""}
      </span>
    </div>
  );
}
